<!-- Trials -->
<div
  class="p-2 font-bold text-sm flex align-items-center justify-content-between"
  [attr.data-testid]="'trials-header'"
>
  <div [attr.data-testid]="'trial-since-section'">
    @if (!showSkeleton) {
      <div [attr.aria-label]="'trial-since-label'">
        {{ 'CLIENT_TRIAL.TRIAL_TAKEN_SINCE' | translate }}
        @if (trialSinceDate) {
          <strong [attr.data-testid]="'trial-since-date'">{{
            trialSinceDate | datetimeformat: 'defaultformat'
          }}</strong>
        }
        @if (!trialSinceDate) {
          <strong [attr.data-testid]="'trial-since-dash'">-</strong>
        }
      </div>
    }
    @if (showSkeleton) {
      <p-skeleton
        height="1.5rem"
        styleClass="w-10rem"
        [attr.data-testid]="'trial-since-skeleton'"
      />
    }
  </div>

  <div (click)="createNewTrial()" [attr.data-testid]="'create-trial-button'">
    <p-button
      icon="fa fa-plus"
      styleClass="p-button-outlined surface-0"
      [label]="'CLIENT_TRIAL.CLIENT_TRIALS' | translate"
      styleClass="text-sm hidden md:inline-block"
      [attr.aria-label]="'create-trial-button'"
    />
    <p-button
      icon="fa fa-plus"
      styleClass="p-button-outlined surface-0"
      [label]="'CLIENT_TRIAL.CLIENT_TRIALS' | translate"
      styleClass="md:hidden"
      [attr.aria-label]="'create-trial-button-mobile'"
    />
  </div>
</div>
<!-- Trials -->

<!-- Card -->
<div class="text-sm mt-3" [attr.data-testid]="'client-trials-section'">
  <div class="surface-0 border-1 border-300">
    <div class="p-3">
      <h6 class="text-sm mb-0" [attr.data-testid]="'client-trials-title'">
        {{ 'CLIENT_TRIAL.CLIENT_TRIALS' | translate }}
      </h6>
    </div>

    <app-data-grid
      [columnData]="clientTrialData$"
      [columns]="clientTrialTablecolumns$"
      [selectable]="selecallTrialData"
      tableClasses="p-0 my-3"
      [headerClasses]="'surface-100 text-xs text-600 white-space-nowrap'"
      [paginator]="false"
      [EmptyState]="emptyStateComponent$"
      (onAction)="onActionEventForTrial($event)"
      [loading]="loading"
      [gridName]="'client-trial-list'"
      aria-label="client-trial-table"
      data-testid="client-trial-table"
    />
  </div>
</div>
<!-- Card -->

<!-- Card -->
@if (isClassBasedActive) {
  <div class="text-sm mt-3" [attr.data-testid]="'trial-class-bookings-section'">
    <div class="surface-0 border-1 border-300">
      <div class="p-3">
        <h6
          class="text-sm mb-0"
          [attr.data-testid]="'trial-class-bookings-title'"
        >
          {{ 'CLIENT_TRIAL.TRIAL_CLASS_BOOKING' | translate }}
        </h6>
      </div>
      <app-data-grid
        [columnData]="ClassBasedClientTrialData$"
        [columns]="ClassBasedClientTrialTablecolumns$"
        [selectable]="selecallTrialData"
        tableClasses="p-0 my-3"
        [headerClasses]="'surface-100 text-xs text-600 white-space-nowrap'"
        [paginator]="false"
        [EmptyState]="emptyStateComponentForTrialBooking$"
        (onAction)="onActionEvent($event)"
        [loading]="loading"
        [gridName]="'class-based-client-trial-list'"
        aria-label="class-based-client-trial-table"
        data-testid="class-based-client-trial-table"
      />
    </div>
  </div>
}
<!-- Card -->

<!-- Trial History -->
@if ({ showTrialHistory: showTrialHistory | async }; as $) {
  <p-dialog
    [visible]="$.showTrialHistory"
    [resizable]="false"
    appendTo="body"
    [modal]="true"
    [breakpoints]="{ '767px': '100vw' }"
    [style]="{ width: '550px' }"
    styleClass="no-header-modal overflow-visible"
    [attr.aria-label]="'trial-history-dialog'"
    [attr.data-testid]="'trial-history-dialog'"
  >
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div
        class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h2 class="mb-0 text-sm" [attr.data-testid]="'trial-history-title'">
          {{ 'CLIENT_TRIAL.TRIAL_HISTORY' | translate }}
        </h2>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="CloseTralHistory()"
          [attr.aria-label]="'close-trial-history-button'"
          [attr.data-testid]="'close-trial-history-button'"
        ></div>
      </div>
      <!-- Header -->
      <!-- Table -->
      <app-data-grid
        [columnData]="trialHistoryData$"
        [columns]="trialHistoryDataTablecolumns$"
        [selectable]="selecallTrialData"
        tableClasses="p-0 border-1 border-300"
        [headerClasses]="'text-xs text-600 white-space-nowrap'"
        [paginator]="false"
        [EmptyState]="emptyStateComponentForHistory$"
        [EmptyStateClass]="'pt-1 pb-2 text-center surface-0'"
        [gridName]="'trial-history-list'"
        aria-label="trial-history-table"
        data-testid="trial-history-table"
      />
      <!-- Table -->
    </ng-template>
  </p-dialog>
}
<!-- Trial History -->

@if (showDaysBased) {
  <create-client-trial
    [visible]="showDaysBased"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [clientId]="clientId()"
    [tenantId]="tenantId"
    (closeEvent)="closeEvent($event)"
    [attr.data-testid]="'create-client-trial-dialog'"
  />
}

@if (showClassBased) {
  <client-trial-studio
    [visible]="showClassBased"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [showCreateTrialButton]="showCreateTrialButton"
    [clientId]="clientId()"
    [tenantId]="tenantId"
    (closeEvent)="closeEvent($event)"
    (createTrial)="createTrial($event)"
    [attr.data-testid]="'client-trial-studio-dialog'"
  />
}
